// extracted by mini-css-extract-plugin
export default {"oneQualification":"Cv0qR4fO","updateCancel":"_257LaH5f","btnUpdateCancel":"_3EhjpPIR","warning":"_3EyEsYfN"};